import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
const SelectorSize = (props) => {
    const { t } = useTranslation();
    const id = useMemo(() => `item_${props.value}${props.isQuickBuy ? '_quickbuy' : props.isSizeInStickyTray ? '_stickytry' : ''}`, [props.value]);
    return (React.createElement("div", { className: classNames('selector-size-item', props.disabled && 'disabled', props.selected && 'selected') },
        React.createElement("input", { className: "selector-size-item__input", id: id, type: "radio", onChange: props.onSelect, name: `size-selector-${props.variationGroupId}`, value: props.value, "aria-label": props.label + ' ' + (props.disabled ? t('label.outofstocksize') + '-' + t('label.notifyme') : '') }),
        React.createElement("label", { htmlFor: id, className: "selector-size-item__label", "aria-hidden": true }, props.label)));
};
export default SelectorSize;
